import { updateTouristVisaNotification, updateGlobalTalentVisaNotification } from '../../../services/userService';
import { getAuth } from 'firebase/auth';
import {
    UpdateNotificationPreferenceResponse
} from '../types/user.types';

export class UserProfileService {
    /**
     * Update user's tourist visa notification preference
     * This function directly updates Firestore since we're using Firebase for user data
     */
    static async updateTouristVisaNotificationPreference(
        notifyOnTouristVisa: boolean
    ): Promise<UpdateNotificationPreferenceResponse> {
        try {
            const auth = getAuth();
            const user = auth.currentUser;

            if (!user) {
                throw new Error('User not authenticated');
            }

            // Update Firestore directly
            await updateTouristVisaNotification(user.uid, notifyOnTouristVisa);

            return {
                status: 'success',
                message: notifyOnTouristVisa
                    ? 'You will be notified when Tourist Visa Assistant is available!'
                    : 'Tourist visa notifications turned off.'
            };
        } catch (error) {
            console.error('Error updating tourist visa notification preference:', error);
            return {
                status: 'error',
                message: error instanceof Error ? error.message : 'Failed to update notification preference'
            };
        }
    }

    /**
     * Alternative method using API endpoint (if you decide to implement backend validation)
     * Uncomment and modify if you want to use a backend API instead of direct Firestore access
     */
    /*
    static async updateTouristVisaNotificationPreferenceViaAPI(
        notifyOnTouristVisa: boolean
    ): Promise<UpdateNotificationPreferenceResponse> {
        try {
            const request: UpdateNotificationPreferenceRequest = {
                notifyOnTouristVisa
            };

            const response = await apiService.patch<UpdateNotificationPreferenceResponse>(
                '/api/user/notification-preferences/tourist-visa',
                request
            );

            return response;
        } catch (error) {
            console.error('Error updating tourist visa notification preference via API:', error);
            return {
                status: 'error',
                message: error instanceof Error ? error.message : 'Failed to update notification preference'
            };
        }
    }
    */

    /**
     * Update user's global talent visa notification preference
     */
    static async updateGlobalTalentVisaNotificationPreference(
        notifyOnGlobalTalentVisa: boolean
    ): Promise<UpdateNotificationPreferenceResponse> {
        try {
            const auth = getAuth();
            const user = auth.currentUser;

            if (!user) {
                throw new Error('User not authenticated');
            }

            // Update Firestore directly
            await updateGlobalTalentVisaNotification(user.uid, notifyOnGlobalTalentVisa);

            return {
                status: 'success',
                message: notifyOnGlobalTalentVisa
                    ? 'You will be notified when Global Talent Visa Assistant is available!'
                    : 'Global talent visa notifications turned off.'
            };
        } catch (error) {
            console.error('Error updating global talent visa notification preference:', error);
            return {
                status: 'error',
                message: error instanceof Error ? error.message : 'Failed to update notification preference'
            };
        }
    }
} 